// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"4d3b8b0a","746":"0f673491","858":"3f537fb0"}[chunkId] + ".chunk.js";
};